import { Flex } from '@/common/components';
import { Button, ButtonLink } from '@/common/components/controls';
import { createComponent, If, IntrinsicProps } from '@/common/util/templateHelpers';
import { MouseEventHandler, TouchEventHandler } from 'react';

import style from './index.module.scss';

interface ProductPlanBoxProps extends IntrinsicProps {
  buttonHref?: string
  buttonOnClick?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
  featured?: boolean
  disabled?: boolean
  customCost?: boolean
}

const productPlanBoxClassStates = [
  'featured',
  'disabled'
];

export default createComponent<ProductPlanBoxProps>('ProductPlanBox', 
  { classStates: productPlanBoxClassStates, style }, 
  function ProductPlanBox ({ className, slots }, props) {
    return (
      <Flex className={className} directionColumn wide>
        <Flex wide justifyCenter className='ProductPlanBox__Header --padMd0'>
          <h2>{slots.title}</h2>
          {
            If(slots.sticker, () => (
              <Flex alignCenter justifyCenter className='ProductPlanBox__Sticker'>
                <span>{slots.sticker}</span>
              </Flex>
            ))
              .EndIf()
          }
        </Flex>
        <Flex fit wide className='ProductPlanBox__Content --padSm2'>
          <Flex directionColumn wide alignCenter>
            {
              If(props.customCost, () => (
                <Flex className='ProductPlanBox__Cost'>{slots.cost}</Flex>
              ))
                .Else(() => (
                  <Flex className='ProductPlanBox__Cost --padMd0__t --padSm1__b'>{slots.cost}</Flex>
                ))
                .EndIf()
            }
            <Flex>{slots.description}</Flex>
            {
              If(props.buttonHref || props.buttonOnClick, () => (
                <Flex pullBottom wide className='--padSm2 --padMd1__t'>
                  {
                    If(props.buttonHref, () => (
                      <ButtonLink primary={!!props.featured} fullWidth href={props.buttonHref} className='ProductPlanBox__Button'>
                        {slots.buttonText}
                      </ButtonLink>
                    ))
                      .Else(() => (
                        <Button primary={!!props.featured} disabled={props.disabled} fullWidth onClick={props.buttonOnClick} className='ProductPlanBox__Button'>
                          {slots.buttonText}
                        </Button>
                      ))
                      .EndIf()
                  }
                </Flex>
              )).ElseIf(props.buttonOnClick, () => (
                <Button primary={!!props.featured} fullWidth onClick={props.buttonOnClick} className='ProductPlanBox__Button'>
                  {slots.buttonText}
                </Button>
              )).EndIf()
            }
          </Flex>
        </Flex>
      </Flex>
    );
  });
